// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/update_user_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "../../../../google/protobuf/field_mask_pb";
import { file_google_protobuf_field_mask } from "../../../../google/protobuf/field_mask_pb";
import type { User } from "./user_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/update_user_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_update_user_request: GenFile = /*@__PURE__*/
  fileDesc("CkFxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvdXBkYXRlX3VzZXJfcmVxdWVzdC5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIqQBChFVcGRhdGVVc2VyUmVxdWVzdBJACgR1c2VyGAEgASgLMi0ucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLlVzZXJIAIgBARI0Cgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2tIAYgBAUIHCgVfdXNlckIOCgxfdXBkYXRlX21hc2tiBnByb3RvMw", [file_google_protobuf_field_mask, file_quanterix_simoa_one_analysis_app_api_v1_user]);

/**
 * Rpc request to save a modified user record
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.UpdateUserRequest"> & {
  /**
   * Updated user record to be saved
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.User user = 1;
   */
  user?: User;

  /**
   * Represents a set of field paths to be modified by the update request. If
   * omitted, all fields in user are updated in storage.
   *
   * See: https://protobuf.dev/reference/protobuf/google.protobuf/#field-mask
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_update_user_request, 0);

